export default "__VITE_ASSET__CgF7xrDu__"